import * as React from 'react';
import { createPortal } from 'react-dom';

const domNode = document.createElement('div');
document.body.appendChild(domNode);

const BodyPortal: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return createPortal(children, domNode);
};

export default BodyPortal;
